export const SVG_LINK = 'http://www.w3.org/2000/svg'
export const SVG_X_LINK = 'http://www.w3.org/1999/xlink'
